<script>
	import { onMount } from 'svelte'
  import { fade } from 'svelte/transition'

  import Linkbag from './../components/Linkbag.svelte'
  import Footer from './../components/Footer.svelte'
  
	import { activePage, staticPath } from './../stores.js';
  import toTitleCase from './../transitions/toTitleCase.js'

  let mounted = false

	onMount( () => {
    mounted = true
  })  
</script>

<main>	
  <section class="text-section" id="event" in:fade={{ delay: 250, duration: 250 }} out:fade={{ duration: 250 }}>
    <header class="image-bg">
			{#if mounted}
				<h1 in:toTitleCase={{ duration: 7000}}>VIRTUAL TAIKO</h1>
        <!-- <h1 class="squish">x</h1>
        <h1 class="squish" in:toTitleCase={{ duration: 7000}}>ARTS IN THE PARKS</h1> -->
				<!-- <h1 id="aligner" in:toTitleCase={{ duration: 7000}}>VIRTUAL TAIKO<br>X<br>ARTS IN THE PARKS</h1> -->
			{/if}
		</header>

    <section>
			<h2>episodes</h2>
			<p>Each episode begins with a short video about taiko, followed by a fun quiz. In the second half, learn to play taiko with <a href="https://nagatashachu.com">Nagata Shachu</a> using our virtual drum!</p>
			<ol class="plain" id="episodes">
				<li><a href="#" on:click={ e => {
						e.preventDefault()
						e.stopPropagation()
						activePage.set({page:"instrument", episode: 1})
					}}>Episode 1: Raijin, the God of Thunder</a></li>
				<li><a href="#" on:click={ e => {
						e.preventDefault()
						e.stopPropagation()
						activePage.set({page:"instrument", episode: 2})
					}}>Episode 2: Benten, the Goddess of Art</a></li>
				<li><a href="#" on:click={ e => {
						e.preventDefault()
						e.stopPropagation()
						activePage.set({page:"instrument", episode: 3})
					}}>Episode 3: Fūjin, the God of Wind</a></li>
			</ol>
		</section>

    <section>
			<h2>Video perforMAnce</h2>
			<p>Once you've gone through all three episodes, watch Nagata Shachu's immersive prerecorded 360 degree performance:<br/>
			<!-- <p><a href="https://www.facebook.com/nagatashachu/videos/312987493356493">Watch on Facebook</a><br/> -->
			<a href="https://www.youtube.com/nagatashachu">Watch on YouTube (supports VR headsets)</a></p>
		</section>


    <section>
      <h2>surVey</h2>
      <!-- <p>This event was made possible with the support of Arts in the Parks Anyplace. <a href="https://forms.gle/dMQ8Nhm8T1jesTc46">Tap here to let them know what you thought!</a></p> -->
      <p>This school outreach program was made possible with the support of the Ontario Trillium Foundation.  We kindly request that all teachers and students who participated in today's event complete <a href="https://docs.google.com/forms/d/e/1FAIpQLSewgywiML3y7MNN_bTJh9OIzGJUo0HXoJlnqhuOP-hpnHlEpg/viewform" target="_blank">this short survey.</a></p>
    </section>
    
    <section>
      <h2>Free-play Taiko</h2>
      <p>If you've finished the episodes, concert video and survey, keep on drumming with our <a href="#" on:click={ e => {
          e.preventDefault()
          e.stopPropagation()
          activePage.set({page: "instrument"})
        }}>free-play mode.</a>
      </p>
    </section>
        
    <section>
      <h2>Augmented Reality poster</h2>
      <p>Learn the stories of Nagata Shachu members and their instruments through this <a href="https://nagatashachu.com/stories/assets/p/ARPoster_NS_Informative11x17.pdf">AR Poster</a> 
      created by <a href="https://collective-cam.carrd.co/">CAM Collective.</a>
      </p>
		</section>
    
    <section>
      <h2>bonus MateriAls</h2>
      <p class="mb-0">Still want more? Check out these other exclusive performance videos, documentaries, and resources.</p>
      <details>
        <summary>Tap for more!</summary>
        <Linkbag />
      </details>
    </section>

    <!-- <img class="aitp-logo" srcset={$staticPath + "/images/aitp-logo@1x.png 1x, " + $staticPath + "/images/aitp-logo@2x.png 2x"} src={$staticPath + "/images/aitp-logo@1x.png"} alt="Arts in the Parks logo"> -->
		<Footer />
</main>

<style>

header {
  height: 47vw;
  /* display: flex; */
  /* flex-direction: column; */
  /* justify-content: flex-start; */
  padding-top: 10px;
  padding-bottom: 10px;
}

/* header h1:first-child {
  top: auto;
  margin-top: 4.5vw;
} */

header > h1 {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}

header > h1.squish {
  font-size: 1.4em;
}

@media (min-width:1023px){
  header > h1.squish {
    font-size: 3.5em;
  }
}

.aitp-logo {
  margin: 1em 10px 1em 10px;
}

</style>